export enum MutationTypes {
	routeTo = 'RouteTo',
	toggleMap = 'ToggleMap',
	setMapVisible = 'SetMapVisible',
	toggleSearchBar = 'ToggleSearchBar',
	setAppView = 'SetAppView',
	detailViewSelectMarker = 'detailViewSelectMarker',
	detailViewChangeMode = 'detailViewChangeMode'
}
